// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSE_MENU';
export const WINDOW_WIDTH = 'WINDOW-WIDTH';
export const SWITCH_LANGUAGE = 'SWITCH-LANGUAGE';
export const SET_PAGETITLE = 'SET-PAGETITLE';

//Contact Module const
export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_ERROR = 'fetch_error';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const ON_SHOW_LOADER = 'ON_SHOW_LOADER';
export const ON_HIDE_LOADER = 'ON_HIDE_LOADER';

//Auth const
export const SIGNUP_USER = 'SIGNUP_USER';
export const SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS';
export const SIGNIN_GOOGLE_USER = 'SIGNIN_GOOGLE_USER';
export const SIGNIN_GOOGLE_USER_SUCCESS = 'SIGNIN_GOOGLE_USER_SUCCESS';
export const SIGNIN_FACEBOOK_USER = 'SIGNIN_FACEBOOK_USER';
export const SIGNIN_FACEBOOK_USER_SUCCESS = 'SIGNIN_FACEBOOK_USER_SUCCESS';
export const SIGNIN_TWITTER_USER = 'SIGNIN_TWITTER_USER';
export const SIGNIN_TWITTER_USER_SUCCESS = 'SIGNIN_TWITTER_USER_SUCCESS';
export const SIGNIN_GITHUB_USER = 'SIGNIN_GITHUB_USER';
export const SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_success';
export const SIGNIN_USER = 'SIGNIN_USER';
export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
export const SIGNOUT_USER = 'SIGNOUT_USER';
export const SIGNOUT_USER_SUCCESS = 'SIGNOUT_USER_SUCCESS';
export const INIT_URL = 'INIT_URL';
export const SESSION_KEY_SET = 'session_key_set';
export const ACCESS_TOKEN_SET = "ACCESS_TOKEN_SET";

//LimeSurvey const
export const LIST_SURVEYS = "LIST_SURVEYS"; // list_surveys
export const LIST_SURVEYS_FILTER_TAGS = "LIST_SURVEYS_FILTER_TAGS"; // list_surveys
export const LIST_SURVEYS_FILTER_TAGS_CLIENT = "LIST_SURVEYS_FILTER_TAGS_CLIENT"; //for client assessments
export const GET_ALL_TAGS = "GET_ALL_TAGS";
export const UPDATE_SEARCH_TAGS = "UPDATE_SEARCH_TAGS";
export const GET_SURVEY = "GET_SURVEY";
export const CURR_TAGS = "CURR_TAGS";
export const ADD_PARTICIPANTS = "ADD_PARTICIPANTS"; // add_participants
export const GET_PARTICIPANT = "GET_PARTICIPANT"; // get_participant
export const UPDATE_PARTICIPANT = "UPDATE_PARTICIPANT"; // set_participant_properties
export const INVITE_PARTICIPANTS = "INVITE_PARTICIPANTS"; // invite_participants
export const GET_SURVEY_SUMMARY = "GET_SURVEY_SUMMARY"; // get_summary
export const SURVEY_RESPONSES_BY_TOKEN = "SURVEY_RESPONSES_BY_TOKEN"; // export responses by user-token
export const SURVEY_RESPONSES = "SURVEY_RESPONSES"; // export all responses by survey
export const SURVEY_RESPONSES_SUMMARY = "SURVEY_RESPONSES_SUMMARY"; // Summarise responses into answers assosiative array
export const SURVEY_RESPONSES_BY_CLIENT = "SURVEY_RESPONSES_BY_CLIENT"; // export responses by client's multiple tokens for one assessment
export const SURVEY_RESPONSES_BY_PROJECT = "SURVEY_RESPONSES_BY_PROJECT"; // export responses by project
export const GET_QUESTIONS = "GET_QUESTIONS";
export const CURR_SURVEY = "CURR_SURVEY";
export const GET_QUESTION_CONFIG = "GET_QUESTION_CONFIG";
export const GET_QUESTION_PRO = "GET_QUESTION_PRO";
export const DB_AUTOCOMPLETE_TAG = "DB_AUTOCOMPLETE_TAG";

// Participants (Laravel backend) const
export const DB_LIST_CLIENTS = "DB_LIST_CLIENTS";
export const DB_LIST_CLIENTS_BY_ORGANISATION = "DB_LIST_CLIENTS_BY_ORGANISATION";
export const DB_GET_CLIENT = "DB_GET_CLIENT";
export const DB_ADD_SURVEY_PARTICIPANT = "DB_STORE_PARTICIPANT";
export const DB_CLIENTS_ORG = "DB_CLIENTS_ORG";
export const DB_SEARCH_CLIENT = "DB_SEARCH_CLIENT";
export const DB_AUTOCOMPLETE_CLIENT = "DB_AUTOCOMPLETE_CLIENT";
// Roles
export const DB_LIST_ROLES = "DB_LIST_ROLES";
export const DB_ADD_ROLE = "DB_ADD_ROLE";
export const DB_GET_ROLE = "DB_GET_ROLE";
export const DB_UPDATE_ROLE = "DB_UPDATE_ROLE";
export const DB_DELETE_ROLE = "DB_DELETE_ROLE";

// Permissions
export const DB_LIST_PERMISSIONS = "DB_LIST_PERMISSIONS";

// Users
export const DB_LIST_USERS = "DB_LIST_USERS";
export const DB_ADD_USER = "DB_ADD_USER";
export const DB_GET_USER = "DB_GET_USER";
export const DB_UPDATE_USER = "DB_UPDATE_USER";
export const DB_DELETE_USER = "DB_DELETE_USER";
export const DB_USERS_ORG = "DB_USERS_ORG";
export const CURR_CTAGS = "CURR_CTAGS";
export const UPDATE_SEARCH_CTAGS = "UPDATE_SEARCH_CTAGS";
export const DB_AUTOCOMPLETE_CTAG = "DB_AUTOCOMPLETE_CTAG";
export const GET_ALL_CTAGS = "GET_ALL_CTAGS";

// Clients - Assessments Tab
export const DB_QUESTION_GROUP = "DB_QUESTION_GROUP";

// Clients - Correspondence Tab
export const DB_SAVE_CORRESPONDENCE = "DB_SAVE_CORRESPONDENCE";
export const DB_LIST_CORRESPONDENCE = "DB_LIST_CORRESPONDENCE";
export const DB_GET_CORRESPONDENCE = "DB_GET_CORRESPONDENCE";

// Assessments Page
export const CLIENT_TAB_ASSESSMENTS_TABLE = "CLIENT_TAB_ASSESSMENTS_TABLE";
export const DB_CLIENT_SURVEYS = "DB_CLIENT_SURVEYS";
export const DB_CLIENT_SURVEYS_NOT_FILTER = "DB_CLIENT_SURVEYS_NOT_FILTER";
export const GET_SURVEY_DESCRIPTION = "GET_SURVEY_DESCRIPTION";
export const LIST_CONFIG_SURVEY = "LIST_CONFIG_SURVEY";
export const SURVEY_BY_ORGANISATION = "SURVEY_BY_ORGANISATION";
export const DB_RESPONSE_BY_CLIENT = "DB_RESPONSE_BY_CLIENT";
export const DB_RESPONSE_BY_TOKEN = "DB_RESPONSE_BY_TOKEN";
export const SELECTED_SCORE = "SELECTED_SCORE";
export const SELECTED_SCORE_BAR = "SELECTED_SCORE_BAR";
export const SELECTED_SCORE_LINE = "SELECTED_SCORE_LINE";
export const DB_TEMPLATES = "DB_TEMPLATES";
export const DB_TEMPLATE_ID = "DB_TEMPLATE_ID";
export const DB_DEFAULT_TEMPLATE = "DB_DEFAULT_TEMPLATE";
export const DB_QUICKVIEW_TEMPLATE = "DB_QUICKVIEW_TEMPLATE";
export const ASSESSMENT_QUESTIONS = "ASSESSMENT_QUESTIONS";
export const ASSESSMENT_QUESTION_GROUP = "ASSESSMENT_QUESTION_GROUP";
export const DB_AUTOCOMPLETE_TAG_ASSESSMENT = "DB_AUTOCOMPLETE_TAG_ASSESSMENT";

// Notes
export const DB_CLIENT_NOTES = "DB_CLIENT_NOTES";
export const DB_CURR_NOTE = "DB_CURR_NOTE";

// Projects
export const DB_LIST_PROJECTS = "DB_LIST_PROJECTS";
export const DB_GET_PROJECT = "DB_GET_PROJECT";
export const DB_PROJECT_SURVEYS = "DB_PROJECT_SURVEYS";
export const DB_PROJECT_CLIENTS = "DB_PROJECT_CLIENTS";
export const PROJECT_SURVEY_SYNC_PENDING = "PROJECT_SURVEY_SYNC_PENDING";
export const PROJECT_SURVEY_SYNC_NUM = "PROJECT_SURVEY_SYNC_NUM";
export const PROJECT_SET_PROPERTY_PENDING = "PROJECT_SET_PROPERTY_PENDING";
export const PROJECT_SET_PROPERTY_NUM = "PROJECT_SET_PROPERTY_NUM";
export const DB_PROJECT_CHARTS = "DB_PROJECT_CHARTS";
export const DB_PROJECT_CHART_CLIENTS = "DB_PROJECT_CHART_CLIENTS";

// Organisations
export const DB_LIST_ORGANISATIONS = "DB_LIST_ORGANISATIONS";
export const DB_GET_ORGANISATION = "DB_GET_ORGANISATION";
export const DB_ORGANISATION_SURVEYS = "DB_ORGANISATION_SURVEYS";
export const DB_ORGANISATION_CLIENTS = "DB_ORGANISATION_CLIENTS";
export const DB_LAYOUT = "DB_LAYOUT";

//Textblocks
export const DB_LIST_TEXTBLOCKS = "DB_LIST_TEXTBLOCKS";
export const DB_GET_TEXTBLOCK = "DB_GET_TEXTBLOCK";
export const TEXTBLOCKS_BY_ORG = "TEXTBLOCKS_BY_ORG";
export const TEXTBLOCKS_BY_ORG_CORR = "TEXTBLOCKS_BY_ORG_CORR";

//Explainer
export const DB_LIST_EXPLAINERS = "DB_LIST_EXPLAINERS";
export const DB_GET_EXPLAINER = "DB_GET_EXPLAINER";

//Sync
export const SYNC_SURVEY_INFO = "SYNC_SURVEY_INFO";
export const SYNCED_SURVEY_NUM = "SYNCED_SURVEY_NUM";
export const SYNCED_SURVEYS_ADD = "SYNCED_SURVEYS_ADD";
export const SYNCED_SURVEYS_UPDATE = "SYNCED_SURVEYS_UPDATE";

//Dashboard
export const DB_LIST_INVITATIONS = "DB_LIST_INVITATIONS";
export const DASHBOARD_CLIENT = "DASHBOARD_CLIENT";
export const DB_DASHBOARD_CONTENT = "DB_DASHBOARD_CONTENT";

//Bannerblocks
export const DB_LIST_BANNERBLOCKS = "DB_LIST_BANNERBLOCKS";
export const DB_GET_BANNERBLOCK = "DB_GET_BANNERBLOCK";
export const DB_LIST_BANNERBLOCKS_USER = "DB_LIST_BANNERBLOCKS_USER";

//Deploy
export const DEPLOY_LOG_LIST = "DEPLOY_LOG_LIST";
export const DEPLOY_LOG_GET = "DEPLOY_LOG_GET";
export const DEPLOY_CURR_LOG = "DEPLOY_CURR_LOG";

//Trial
export const DB_LIST_TRIAL_USERS = "DB_LIST_TRIAL_USERS";

